var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.429199,
    y: 0.164062,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FAE5E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0096 11.2007C17.3007 9.99561 15.558 9.99561 14.8492 11.2007L10.5137 18.5709C9.7948 19.7931 10.676 21.3338 12.0939 21.3338H20.7648C22.1827 21.3338 23.0639 19.7931 22.345 18.5709L18.0096 11.2007Z",
    fill: "#E72222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4292 12.3359C16.7053 12.3359 16.9292 12.5598 16.9292 12.8359V16.8359C16.9292 17.1121 16.7053 17.3359 16.4292 17.3359C16.1531 17.3359 15.9292 17.1121 15.9292 16.8359V12.8359C15.9292 12.5598 16.1531 12.3359 16.4292 12.3359Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4292 17.6641C16.7053 17.6641 16.9292 17.8879 16.9292 18.1641V19.1641C16.9292 19.4402 16.7053 19.6641 16.4292 19.6641C16.1531 19.6641 15.9292 19.4402 15.9292 19.1641V18.1641C15.9292 17.8879 16.1531 17.6641 16.4292 17.6641Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.f2f5efa418bd9ec997ad63907ffe8678.svg";
export { ForwardRef as ReactComponent };